/* @flow */

export function getSentryDsn(projectId: string, publicKey: string): string {
  return `https://${publicKey}@sentry.e-180.com/${projectId}`;
}
